module.exports = __webpack_public_path__ + "public/img/C2QB_green_btn_med_hover.6e5cf0cb.png";